import http from '../components/services/HttpService';
export const imageRoot = () => `${http.getApiHost()}/images`;

//Department
export const departmentImagePath = (imageName = '') =>
  `${imageRoot()}/departments/${!!imageName ? imageName : 'image_de.png'}`;

//User
export const userAvatarPath = (imageName = '') =>
  `${imageRoot()}/users-avatar/${!!imageName ? imageName : 'avatar.png'}`;

//Language
export const languageImagePath = (imageName) => `${imageRoot()}/languages/${imageName}`;

//Vehicle
export const vehicleImagePath = (imageName = '') =>
  `${imageRoot()}/vehicles/${!!imageName ? imageName : 'image_de.png'}`;

//Insurance
export const insuranceImagePath = (imageName = '') =>
  `${imageRoot()}/insurances/${!!imageName ? imageName : 'image_de.png'}`;

//Reason driver decline
export const reasonDriverDeclineImagePath = (imageName = '') =>
  `${imageRoot()}/reasons/driver-decline/${!!imageName ? imageName : 'no_image.png'}`;

//Reason patient cancel
export const reasonPatientCancelImagePath = (imageName = '') =>
  `${imageRoot()}/reasons/patient-cancel/${!!imageName ? imageName : 'no_image.png'}`;

//Vehicle equipment
export const vehicleEquipmentImagePath = (imageName = '') =>
  `${imageRoot()}/vehicle-equipment/${!!imageName ? imageName : 'no_image.png'}`;

//Vehicle capacity type
export const vehicleCapacityTypeImagePath = (imageName = '') =>
  `${imageRoot()}/vehicle-capacity-type/${!!imageName ? imageName : 'no_image.png'}`;

//Vehicle capacity
export const vehicleCapacityImagePath = (imageName = '') =>
  `${imageRoot()}/vehicle-capacity/${!!imageName ? imageName : 'no_image.png'}`;
